import {
  isPaysonicHost,
  isPrimeBrazilOnlyHost,
} from "src/config/deploymentConfig";

const SignUpCarouselDesktop = () => {
  const isPrimeBrazilOnly = isPrimeBrazilOnlyHost();
  const isPaysonic = isPaysonicHost();

  const panelTitle = isPrimeBrazilOnly
    ? "ADMIN PANEL"
    : isPaysonic
      ? "PAYSONIC ADMIN PANEL"
      : "TYLT ADMIN PANEL";

  return (
    <div className="flex flex-col items-center h-full my-auto justify-center -mt-24 text-[#ffffff] px-[85px]">
      <div className="font-bold text-[30px] leading-[50px] text-center">
        <p>{panelTitle}</p>
        <p>
          MANAGE OPERATIONS <br /> WITH EASE.
        </p>
      </div>
      <div className="text-center w-[25dvw] mt-[20px]">
        <p className="line-clamp-4 md:line-clamp-4 font-medium text-[14px]">
          Manage your operations efficiently. Monitor transactions, oversee
          users, and configure platform settings with comprehensive admin tools.
        </p>
      </div>
    </div>
  );
};

export default SignUpCarouselDesktop;
